import React, { Component } from 'react';
import Slider from 'react-slick';
import { Button } from 'reactstrap';
import 'sweetalert2/dist/sweetalert2.css';
import language from '../../../../assets/languages/language';
import { questionsettings } from '../../../../common/cbtleftnavigationsettings';
import { caseCV } from '../../../../common/cbttopnavigationsettings';
import Loader from '../../../../common/loader';
import CBTFinishTest from '../../../Common/CBTFinishTest';
import CBTFlagged from '../../../Common/CBTFlagged';
import CBTNonAttempted from '../../../Common/CBTNonAttempted';
import FD from '../../../RestAPI/fetchData';
import AppRoutes from '../../../config/AppRoutes';
import App_data from '../../../config/App_data';

import { SecondsToHHMMSS, optionsArr } from '../../../../common/constant';
import { clearSelection, highlightString } from '../../../../common/highlightText';
import ViewAnswer from '../../../CFA3/Cfa3EssayQuestions/Layout/ViewAnswer';
import ViewEssayQuestions from './ViewEssayQuestionChoices';
import ViewNormalAnswer from './ViewNormalAnswer';
import ViewNormalQuestion from './ViewNormalQuestionChoices';
import { renderHTMLContent } from '../../../../common/function';
/* eslint-disable*/
let attemptedCaseArray = [];
const longPressDuration = 450;
class CFAQuestions extends Component {
  selectionShare;
  constructor(props) {
    super(props);
    this.state = {
      questionsData: [],
      isLoading: true,
      isDataLoading: true,
      token: '',
      idname: '',
      userStatsData: '',
      time: {},
      seconds: params.timer === 'undefined' || params.timer == undefined ? 8100 : parseInt(timer),

      timer: params.timer === 'undefined' || params.timer == undefined ? 8100 : parseInt(timer),
      showFinishTestPopup: false,
      mockName: '',
      flag: [],
      showSectionReview: false,
      showAttempted: false,
      showUnattempted: false,
      showFlagged: false,
      filter: [],
      showNonAttemptedPopup: false,
      showFlaggedPopup: false,
      selectedQuestionData: [],
      runDecrement: true,
      isNegative: false,
      timerStart: params.timerStart,
      selectedQuestion: '',
      highlights: [],
      showPopover: false,
      strikeThroughArr: [],
      vpCaseLoader: true,
      questionLoader: true,
      readingViseScore: '',
      report_block: 'card hide_block',
      totalMaxGrading: 0,
      disabledTextArea: true,
      totalQuestionCount: 0,
    };
    this.longPressCountdown = null;
    this.timer = 0;
    this.countDown = this.countDown.bind(this);
    this.isPathway = this.props.location.pathname.includes(AppRoutes.CFA3_PATHWAY_CBT);
    this.finishTestRoute = this.isPathway
      ? AppRoutes.CFA3_PATHWAY_CBT_QUESTIONS_FINISH
      : AppRoutes.CFA3_CBT_QUESTIONS_FINISH;
    this.attemptedTestRoute = this.isPathway
      ? AppRoutes.CFA3_PATHWAY_CBT_VIEW_ATTEMPTED_MOCK
      : AppRoutes.CFA3_CBT_VIEW_ATTEMPTED_MOCK;
    this.detailsGraphRoute = this.isPathway
      ? AppRoutes.CFA3_PATHWAY_CBT_DETAILED_RESULT_GRAPH
      : AppRoutes.CFA3_CBT_DETAILED_RESULT_GRAPH;
  }

  //it is use to redirect page
  static contextTypes = {
    router: React.PropTypes.object,
  };

  componentDidUpdate = (prevProps) => {
    var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
    if (
      prevProps.params.caseOffset !== this.props.params.caseOffset ||
      prevProps.params.quesOffset !== this.props.params.quesOffset
    ) {
      const { id, testid } = this.props.params;
      const data = {
        token: storage_session['token'],
        idname: storage_session['idname'],
        mock_id: id ? parseInt(id) : null,
        test_id: testid,
      };
      this.getCases(data);
      this.getUserStats();
      this.getFlagQuestions();
    }
  };

  getFlagQuestions = () => {
    var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
    const data = {
      token: storage_session['token'],
      idname: storage_session['idname'],
      test_id: this.props.params.testid ? parseInt(this.props.params.testid) : null,
    };
    FD.callAPI(App_data.backend_api + '/cfa3CBTMockExams/getflaggedQuestions', data).then(
      async (res) => {
        if (res) {
          this.setState({ flag: res.data });
        }
      },
    );
  };

  componentDidMount = async () => {
    window.scrollTo(0, 0);
    var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
    this.setState({
      token: storage_session['token'],
      idname: storage_session['idname'],
    });
    const { id, testid } = this.props.params;
    const data = {
      token: storage_session['token'],
      idname: storage_session['idname'],
      mock_id: id ? parseInt(id) : null,
      test_id: testid,
    };
    this.getCases(data);
    this.getUserStats();
    this.getFlagQuestions();

    if (params.timerStart === 'true') {
      this.timer = setInterval(this.countDown, 1000);
    } else {
      clearInterval(this.timer);
    }
    FD.callAPI(App_data.backend_api + '/cfa3CBTMockExams/getMockNamebyId', data).then(
      async (res) => {
        await this.getTotalQuestionsCount(data);
        await this.getrightanswer();
        this.setState({
          mockName: res.mockdata && res.mockdata.mock_exam ? res.mockdata.mock_exam : '',
        });
      },
    );
  };

  getDetailedResultGraph = (totalQuestion) => {
    const {
      props: {
        params: { id, testid, timer },
      },
      state: { isNegative, totalMaxGrading },
    } = this;
    let path = this.detailsGraphRoute
      .replace(':id', id)
      .replace(':test_id', testid)
      .replace(':totalQuestions', totalQuestion)
      .replace(':totalMarks', totalMaxGrading)
      .replace(':timer', timer)
      .replace(':isNegative', isNegative);
    this.context.router.push({
      pathname: path,
    });
  };

  getCases = (data) => {
    this.setState({
      display_main_loader: 'show_block z-index-1000 bg-white',
      vpCaseLoader: true,
      questionLoader: true,
    });
    FD.callAPI(
      `${App_data.backend_api}/${
        this.isPathway ? 'cfa3PathwayExams' : 'cfa3CBTMockExams'
      }/getCFAMockCases`,
      data,
    ).then((resp) => {
      if (resp.success) {
        if (resp.question && resp.question.length) {
          this.setState({
            casesData: resp.question,
            isLoading: false,
            isDataLoading: false,
            vpCaseLoader: false,
            questionLoader: false,
            ...(this.isPathway && { totalQuestionCount: resp.data && resp.data.length }),
            display_main_loader: 'hide_block',
            //selected case
            selectedQuestionData: resp.question[this.props.params.caseOffset],
            //all questions of selected case
            questionsData:
              resp.question[this.props.params.caseOffset] &&
              resp.question[this.props.params.caseOffset].cfa3_cbt_questions
                ? resp.question[this.props.params.caseOffset].cfa3_cbt_questions
                : [],
            //1st question of selected case
            selectedCaseQuestionData:
              resp.question[this.props.params.caseOffset] &&
              resp.question[this.props.params.caseOffset].cfa3_cbt_questions &&
              resp.question[this.props.params.caseOffset].cfa3_cbt_questions[
                this.props.params.quesOffset
              ]
                ? resp.question[this.props.params.caseOffset].cfa3_cbt_questions[
                    this.props.params.quesOffset
                  ]
                : [],
          });
        } else {
          // success:true but no cases returned — still clear the loader so
          // the user sees an empty state instead of an infinite spinner.
          this.setState({
            casesData: [],
            questionsData: [],
            selectedQuestionData: null,
            selectedCaseQuestionData: null,
            isLoading: false,
            isDataLoading: false,
            vpCaseLoader: false,
            questionLoader: false,
            display_main_loader: 'hide_block',
          });
        }
      } else {
        this.setState({
          isLoading: false,
          isDataLoading: false,
          vpCaseLoader: false,
          questionLoader: false,
          display_main_loader: 'hide_block',
        });
      }
    });
  };

  changeCase = (questionNumber, index) => {
    const { casesData } = this.state;
    this.getUserStats();
    // this.getFlagQuestions();
    this.setState({
      isLoading: true,
    });
    const { props, state } = this;
    const { token, idname } = state;
    const { id = 0, caseOffset, testid, timer } = props.params;
    const data = {
      token,
      idname,
      mock_id: parseInt(id, 10),
    };
    if (questionNumber) {
      let path = this.finishTestRoute
        .replace(':id', id)
        .replace(':caseno', questionNumber)
        .replace(
          ':questiono',
          casesData[parseInt(caseOffset)] && casesData[parseInt(caseOffset)].cfa3_cbt_questions[0]
            ? casesData[parseInt(caseOffset)].cfa3_cbt_questions[0].id
            : 1,
        )
        .replace(':testid', testid)
        .replace(':caseOffset', index)
        .replace(':quesOffset', 0)
        .replace(':timer', timer);
      this.context.router.push(
        {
          pathname: path,
        },
        // this.getCases(data)
      );
    }
  };

  getUserStats = () => {
    var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
    const { id, testid } = this.props.params;
    var data = {
      token: storage_session['token'],
      idname: storage_session['idname'],
      mock_id: id ? parseInt(id) : null,
      id: testid ? parseInt(testid) : null,
    };
    FD.callAPI(App_data.backend_api + '/cfa3CBTMockExams/getUsersStats', data).then((resp) => {
      if (resp.success) {
        const { timer } = this.state;
        const { user_time_value, isNegative, pathway_id, session_id, attemptedCases } = resp.data;
        this.setState({
          userStatsData: resp.data,
          seconds: user_time_value ? user_time_value : parseInt(timer),
          isNegative: isNegative,
          pathwayId: pathway_id,
          sessionId: session_id,
        });

        attemptedCaseArray = attemptedCases != null ? JSON.parse(attemptedCases) : [];
      } else {
        this.setState({
          isLoading: false,
        });
      }
    });
  };
  changeQuestion = (questionNumber, index) => {
    this.setState({ report_block: 'card hide_block', successAlert: false });
    this.getUserStats();
    if (questionNumber) {
      const { timer } = this.state;
      const { id, caseno, testid, caseOffset } = this.props.params;
      let path = this.finishTestRoute
        .replace(':id', id)
        .replace(':caseno', caseno)
        .replace(':questiono', questionNumber)
        .replace(':testid', testid)
        .replace(':caseOffset', caseOffset)
        .replace(':quesOffset', index)
        .replace(':timer', timer);
      this.context.router.push({
        pathname: path,
      });
    }
  };

  getNextCase = () => {
    const { casesData } = this.state;
    this.setState({
      isLoading: true,
    });
    this.slider.slickGoTo(3);
    const { timer } = this.state;
    const { id, testid, caseOffset } = this.props.params;
    let path = this.finishTestRoute
      .replace(':id', id)
      .replace(':caseno', caseOffset ? casesData[parseInt(caseOffset) + 1].id : 1)
      .replace(
        ':questiono',
        casesData[parseInt(caseOffset) + 1] &&
          casesData[parseInt(caseOffset) + 1].cfa3_cbt_questions[0]
          ? casesData[parseInt(caseOffset) + 1].cfa3_cbt_questions[0].id
          : 1,
      )
      .replace(':testid', testid)
      .replace(':caseOffset', caseOffset ? parseInt(caseOffset) + 1 : 1)
      .replace(':quesOffset', 0)
      .replace(':timer', timer);

    this.context.router.push({
      pathname: path,
    });
  };

  getPreviousCase = () => {
    const { casesData, timer } = this.state;

    this.setState({
      isLoading: true,
    });
    this.slider.slickGoTo(3 - 2);

    let path = this.finishTestRoute
      .replace(':id', this.props.params.id)
      .replace(
        ':caseno',
        this.props.params.caseOffset ? casesData[parseInt(this.props.params.caseOffset) - 1].id : 1,
      )
      .replace(
        ':questiono',
        casesData[parseInt(this.props.params.caseOffset) - 1] &&
          casesData[parseInt(this.props.params.caseOffset) - 1].cfa3_cbt_questions[0]
          ? casesData[parseInt(this.props.params.caseOffset) - 1].cfa3_cbt_questions[0].id
          : 1,
      )
      .replace(':testid', this.props.params.testid)
      .replace(
        ':caseOffset',
        this.props.params.caseOffset ? parseInt(this.props.params.caseOffset) - 1 : 1,
      )
      .replace(':quesOffset', 0)
      .replace(':timer', timer);
    this.context.router.push({
      pathname: path,
    });
  };

  getPreviousQuestion = (index) => {
    const { questionsData } = this.state;
    const { id, caseOffset, quesOffset, testid, timer } = this.props.params;
    let path = this.finishTestRoute
      .replace(':id', id)
      .replace(':caseno', caseOffset)
      .replace(':questiono', quesOffset ? questionsData[parseInt(quesOffset) - 1].id : 1)
      .replace(':testid', testid)
      .replace(':caseOffset', caseOffset)
      .replace(':quesOffset', quesOffset ? parseInt(quesOffset) - 1 : 1)
      .replace(':timer', timer);
    this.context.router.push({
      pathname: path,
    });
  };

  getNextQuestion = (index) => {
    const { questionsData } = this.state;
    const { id, timer, caseOffset, quesOffset, testid } = this.props.params;
    let path = this.finishTestRoute
      .replace(':id', id)
      .replace(':caseno', caseOffset)
      .replace(':questiono', quesOffset ? questionsData[parseInt(quesOffset) + 1].id : 1)
      .replace(':testid', testid)
      .replace(':caseOffset', caseOffset)
      .replace(':quesOffset', quesOffset ? parseInt(quesOffset) + 1 : 1)
      .replace(':timer', timer);
    this.context.router.push({
      pathname: path,
    });
  };

  addHighlight = async (text) => {
    var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
    const { selectedQuestionData } = this.state;

    let data = {
      token: storage_session['token'],
      idname: storage_session['idname'],
      mock_id: this.props.params.id ? parseInt(this.props.params.id) : null,
      question_id: selectedQuestionData.id,
      test_id: this.props.params.testid ? parseInt(this.props.params.testid) : null,
      type: 'highlight',
      text: text,
    };
    await FD.callAPI(App_data.backend_api + '/cfa3CBTMockExams/addHighlightedText', data).then(
      async (res) => {
        this.setState({ showPopover: false });
        await this.getHighlightedText();
        clearSelection();
      },
    );
  };

  deleteHighlight = async (id) => {
    var storage_session = JSON.parse(localStorage.getItem('localstorageval'));

    let data = {
      token: storage_session['token'],
      idname: storage_session['idname'],
      mock_id: this.props.params.id ? parseInt(this.props.params.id) : null,
      id: id,
    };

    if (id) {
      await FD.callAPI(App_data.backend_api + '/cfa3CBTMockExams/deleteHighlightedText', data).then(
        async (res) => {
          this.setState({ showPopover: false });
          await this.getHighlightedText();
          clearSelection();
        },
      );
    } else {
      return;
    }
  };

  getHighlightedText = () => {
    var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
    let data = {
      token: storage_session['token'],
      idname: storage_session['idname'],
      mock_id: this.props.params.id ? parseInt(this.props.params.id) : null,
      question_id: this.props.params.questiono ? parseInt(this.props.params.questiono) : null,
      test_id: this.props.params.testid ? parseInt(this.props.params.testid) : null,
    };
    FD.callAPI(App_data.backend_api + '/cfa3CBTMockExams/getHighlightedText', data).then(
      async (res) => {
        this.setState({
          highlights: res.questions,
        });
      },
    );
  };

  getMobileOperatingSystem = () => {
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;
    //console.log('userAgent', userAgent);
    // Windows Phone must come first because its UA also contains "Android"
    if (/windows phone/i.test(userAgent)) {
      return 'Windows Phone';
    }

    if (/android/i.test(userAgent)) {
      return 'Android';
    }

    // iOS detection from: http://stackoverflow.com/a/9039885/177710
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      return 'iOS';
    }

    return 'unknown';
  };

  clickOption = async (choice, questionId, selectedQuestionData, e) => {
    //console.log('e. type ___________', e.type);
    e.preventDefault();
    // on left click
    if (e.type === 'click') {
      //console.log('Left click');
      // console.log('Print params ---------> ', this.props.params);
      const userData = {
        token: this.state.token,
        idname: this.state.idname,
        mock_id: this.props.params.id ? parseInt(this.props.params.id) : null,
        choice: choice,
        questionId: questionId,
        id: this.props.params.testid ? parseInt(this.props.params.testid) : null,
        offset: this.props.params.quesOffset ? parseInt(this.props.params.quesOffset) : null,
        caseno: this.props.params.caseno ? parseInt(this.props.params.caseno) : null,
        caseOffset: this.props.params.caseOffset ? parseInt(this.props.params.caseOffset) : null,
      };
      this.updateSelectedChoice(userData, selectedQuestionData, choice);
    } else if (e.type === 'contextmenu') {
      //console.log('Right click');
      //on right click
      this.addStrikeThrough(choice);
    }
  };

  addStrikeThrough = async (choice) => {
    //console.log('inside call apiiiii', choice);
    const { selectedQuestionData } = this.state;
    let data = {
      token: this.state.token,
      idname: this.state.idname,
      mock_id: this.props.params.id ? parseInt(this.props.params.id) : null,
      question_id: selectedQuestionData.id,
      test_id: this.props.params.testid ? parseInt(this.props.params.testid) : null,
      choice: choice,
    };

    await FD.callAPI(App_data.backend_api + '/cfa3CBTMockExams/addStrikeThrough', data).then(
      async (res) => {
        //console.log('resssssssssssssssss', res);
        // this.setState({ showPopover: false });
        await this.getStrikedText();
        // clearSelection();
      },
    );
    // };
  };

  updateSelectedChoice = (userData, selectedQuestionData, choice) => {
    // console.log('userData --------------> ', userData);
    FD.callAPI(App_data.backend_api + '/cfa3CBTMockExams/updateUsersChoice', userData).then(
      async (res) => {
        if (res.success) {
          const ansData = {
            token: this.state.token,
            idname: this.state.idname,
            mock_id: this.props.params.id ? parseInt(this.props.params.id) : null,
            question_id: selectedQuestionData.id,
            answer:
              selectedQuestionData && selectedQuestionData.answer === choice
                ? 'correct'
                : 'incorrect',
            test_id: this.props.params.testid ? parseInt(this.props.params.testid) : null,
            reading_id: selectedQuestionData.chapter_id,
          };
          this.getUserStats();
          FD.callAPI(App_data.backend_api + '/cfa3CBTMockExams/updateUserAnswer', ansData).then(
            async (res) => {},
          );
        }
      },
    );
  };

  countDown() {
    const { runDecrement } = this.state;
    let seconds;
    if (this.state.seconds != 0 && runDecrement && this.state.isNegative === 'true') {
      seconds = this.state.seconds - 1;
    } else {
      seconds = this.state.seconds + 1;
      // '/cfa2cbtquestions/:id/:caseno/:questiono/:timer/:testid/:caseOffset/:quesOffset/:isNegative/:timerStart';
      const { timer } = this.state;
      let path = AppRoutes.CFA3_CBT_QUESTIONS.replace(':id', this.props.params.id)
        .replace(':caseno', this.props.params.caseno)
        .replace(':questiono', this.props.params.questiono)
        .replace(':timer', timer)
        .replace(':testid', this.props.params.testid)
        .replace(':caseOffset', this.props.params.caseOffset)
        .replace(':quesOffset', this.props.params.quesOffset)
        .replace(':isNegative', false)
        .replace(':timerStart', timerStart);
      this.context.router.push({
        pathname: path,
      });
      this.setState({
        runDecrement: false,
      });
    }
    this.setState({
      seconds: seconds,
    });

    let data = {
      token: this.state.token,
      idname: this.state.idname,
      mock_id: this.props.params.id ? parseInt(this.props.params.id) : null,
      timer: seconds,
      isNegative: this.state.isNegative,
      id: this.props.params.testid ? parseInt(this.props.params.testid) : null,
    };
    FD.callAPI(App_data.backend_api + '/cfa3CBTMockExams/updateUserTimer', data).then(
      async (res) => {
        if (res.success) {
        }
      },
    );
  }
  updateUserScore = (score, test_id, mock_id) => {
    var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
    const ansdata = {
      token: storage_session['token'],
      idname: storage_session['idname'],
      mock_id,
      score,
      id: test_id,
    };
    FD.callAPI(App_data.backend_api + '/cfa3CBTMockExams/updateUserScore', ansdata).then(
      (resp_count) => {},
    );
  };
  getTotalQuestionsCount = (data) => {
    FD.callAPI(App_data.backend_api + '/cfa3CBTMockExams/getTotalQuestionsCount', data).then(
      (resp) => {
        if (resp.success && resp.totalQuestionsCount > 0) {
          this.setState({
            totalQuestionCount: resp.totalQuestionsCount,
          });
        } else {
          // console.log('falure --------> ', resp);
        }
      },
    );
  };
  getrightanswer = () => {
    var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
    const ansdata = {
      token: storage_session['token'],
      idname: storage_session['idname'],
      mock_id: this.props.params.id ? parseInt(this.props.params.id) : null,
      test_id: this.props.params.testid ? parseInt(this.props.params.testid) : null,
    };
    FD.callAPI(App_data.backend_api + '/cfa3CBTMockExams/totalCount', ansdata).then(
      (resp_count) => {
        if (resp_count.success) {
          const { totalUserGrading, totalMaxGrading } = resp_count;
          this.setState({
            rightanswercount: totalUserGrading,
            totalMaxGrading: totalMaxGrading,
          });
          this.updateUserScore(totalUserGrading, this.props.params.testid, this.props.params.id);
        } else {
          // console.log(resp_count.success + '------------failure');
        }
      },
    );
  };
  handleScroll = () => {
    window.scroll({
      top: document.body.offsetHeight,
      left: 0,
      behavior: 'smooth',
    });
  };

  changeFilter = (e, type) => {
    const { target } = e;
    const { checked } = target;
    const { filter } = this.state;
    if (checked) {
      let temp = [...filter];
      temp.push(type);
      this.setState({
        filter: temp,
      });
    } else {
      // to uncheck elements
      let prevArray = filter.filter((item) => item !== type);
      this.setState({
        filter: prevArray,
      });
    }
  };

  finishTest = () => {
    const { flag, userStatsData, questionsData } = this.state;
    let userChoice =
      userStatsData && userStatsData.questions ? JSON.parse(userStatsData.questions) : '';
    if (flag && flag.length) {
      this.setState({
        showFlaggedPopup: true,
      });
    } else if (Object.keys(userChoice).length !== questionsData.length) {
      this.setState({
        showNonAttemptedPopup: true,
      });
    } else {
      this.setState({ showFinishTestPopup: true });
    }

    //api to update status of quiz
    let data = {
      token: this.state.token,
      idname: this.state.idname,
      mock_id: this.props.params.id ? parseInt(this.props.params.id) : null,
      id: this.props.params.testid ? parseInt(this.props.params.testid) : null,
      status: 'completed',
    };
    FD.callAPI(App_data.backend_api + '/cfa3CBTMockExams/updateUserQuizStatus', data).then(
      async (res) => {
        if (res.success) {
        }
      },
    );
  };

  componentWillUnmount() {
    clearInterval(this.timer);
  }
  addHighlightToText = () => {
    let text = this.getSelectionHtml();
    this.addHighlight(text);
  };

  deleteHighlightFromText = () => {
    let text = this.getSelectionHtml();

    const { highlights } = this.state;
    let getHighlightedTextData = highlights
      ? highlights.filter((item) => {
          return item.text === text;
        })[0]
      : [];

    this.deleteHighlight(getHighlightedTextData.id);
  };

  getStrikedText = () => {
    var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
    let data = {
      token: storage_session['token'],
      idname: storage_session['idname'],
      mock_id: this.props.params.id ? parseInt(this.props.params.id) : null,
      question_id: this.props.params.questiono ? parseInt(this.props.params.questiono) : null,
      test_id: this.props.params.testid ? parseInt(this.props.params.testid) : null,
    };
    FD.callAPI(App_data.backend_api + '/cfa3CBTMockExams/getStrikedText', data).then(
      async (res) => {
        if (res && res.questions) {
          this.setState({
            strikeThroughArr: JSON.parse(res.questions.choiceArray),
          });
        } else {
          this.setState({
            strikeThroughArr: [],
          });
        }
      },
    );
  };

  getSelectionHtml = () => {
    var html = '';
    if (typeof window.getSelection != 'undefined') {
      var sel = window.getSelection();
      //console.log('heyyyyyyyyyyyyyyyy', sel);
      if (sel.rangeCount) {
        var container = document.createElement('div');
        for (var i = 0, len = sel.rangeCount; i < len; ++i) {
          container.appendChild(sel.getRangeAt(i).cloneContents());
        }
        html = container.innerHTML;
      }
    } else if (typeof document.selection != 'undefined') {
      if (document.selection.type == 'Text') {
        html = document.selection.createRange().htmlText;
      }
    }
    return html;
  };

  // for IOS
  onTouchStart = (e, choice) => {
    e.preventDefault();
    // console.log(' window.navigator', window.navigator);
    const data = this.getMobileOperatingSystem();
    //console.log('datadata', data);
    if (data === 'Android') {
      return;
    } else {
      this.longPressCountdown = setTimeout(() => {
        //console.log('heyyyyyy in longpresssss', this.longPressCountdown);
        this.addStrikeThrough(choice);
      }, longPressDuration);
    }
  };

  onTouchMove = (e) => {
    clearTimeout(this.longPressCountdown);
  };

  onTouchCancel = (e) => {
    clearTimeout(this.longPressCountdown);
  };

  onTouchEnd = (e) => {
    clearTimeout(this.longPressCountdown);
  };

  handleGoBackToMock = () => {
    const { timer, id } = this.props.params;
    const { sessionId, pathwayId } = this.state;
    let path = this.attemptedTestRoute
      .replace(':id', id)
      .replace(':timer', timer)
      .replace(':session', sessionId)
      .replace(':pathway', pathwayId);
    this.context.router.push({
      pathname: path,
    });
  };
  getReadingViseScore = () => {
    const { id, testid } = this.props.params;
    const { token, idname } = this.state;
    const data = {
      token,
      idname,
      mock_id: id ? parseInt(id) : null,
      test_id: testid ? parseInt(testid) : null,
    };
    FD.callAPI(
      `${App_data.backend_api}/${
        this.isPathway ? 'cfa3PathwayExams' : 'cfa3CBTMockExams'
      }/getrightAnswerReadingVise`,
      data,
    ).then(async (res) => {
      let arr = res.questionCount.map((t1) => ({
        ...t1,
        ...res.attemptedQuestion.find(
          (t2) => (this.isPathway ? t2.cfa3_2025_chapter.id : t2.cfa3_chapter.id) === t1.id,
        ),
      }));
      this.setState({
        readingViseScore: arr,
      });
    });
  };

  _hideReportForm = () => {
    document.getElementById('comment').value = '';
    this.setState({ report_block: 'card hide_block', reportError: '' });
  };

  reportQuestion = () => {
    var comment = document.getElementById('comment').value;

    this.setState({
      reportError: '',
    });
    if (comment.length < 2) {
      this.setState({
        reportError: 'Please enter comment',
      });
      return;
    }
    const { timer, caseno, questiono, offset, id, testid, quesOffset, caseOffset } =
      this.props.params;
    // BUG FIX: `questiono` is the position param from the URL (1, 2, 3, …
    // within a case), NOT the cbt_pathway_questions / cfa3_cbt_questions
    // primary key. Saving it as `question_id` broke the admin-side join
    // (`item.cbt_pathway_question` came back null, so the auto-reply payload
    // had an empty `reported_item`). Use the loaded row's actual `.id` —
    // which is what the sibling save/answer calls in this file already
    // use (e.g. lines ~415, 523, 548).
    const { selectedCaseQuestionData, selectedQuestionData } = this.state;
    const realQuestionId =
      (selectedCaseQuestionData && selectedCaseQuestionData.id) ||
      (selectedQuestionData && selectedQuestionData.id) ||
      (questiono ? parseInt(questiono) : null);

    const data = {
      case_id: caseno ? parseInt(caseno) : null,
      token: this.state.token,
      idname: this.state.idname,
      question_id: realQuestionId,
      isEssayQuestion:
        selectedCaseQuestionData &&
        selectedCaseQuestionData.question_type === 'essay_question'
          ? 1
          : 0,
      comment: comment,
      offset: offset ? parseInt(offset) : 0,
      mock_id: id ? parseInt(id) : 0,
      type: !id ? 'pathway' : 'mock',
      timer: timer ? parseInt(timer) : 0,
      test_id: testid ? parseInt(testid) : 0,
      mockName: this.state.mockName,
      quesOffset: quesOffset ? parseInt(quesOffset) : 0,
      caseOffset: caseOffset ? parseInt(caseOffset) : 0,
    };

    this.setState({
      reportLoading: true,
    });
    FD.callAPI(App_data.backend_api + '/cfa3CBTMockExams/reportQuestion', data).then((resp) => {
      if (resp.success) {
        this.setState({
          ValidToken: true,
          successAlert: true,
          reportLoading: false,
        });
        document.getElementById('comment').value = '';
      } else {
        this.setState({ ValidToken: false });
      }
      return resp;
    });
  };
  render() {
    const {
      isLoading,
      questionsData,
      showFinishTestPopup,
      userStatsData,
      mockName,
      flag,
      showSectionReview,
      showNonAttemptedPopup,
      showFlaggedPopup,
      disabledTextArea,
      filter,
      selectedQuestionData,
      isDataLoading,
      seconds,
      timerStart,
      highlights,
      strikeThroughArr,
      casesData,
      vpCaseLoader,
      questionLoader,
      rightanswercount,
      outOfScore,
      selectedCaseQuestionData,
      readingViseScore,
      reportError,
      reportLoading,
      totalMaxGrading,
      totalQuestionCount,
      timer,
    } = this.state;
    let userTime = 0;
    const { params } = this.props;
    if (userStatsData && userStatsData.user_time_value && timer) {
      if (userStatsData.isNegative === 'true') {
        userTime = SecondsToHHMMSS(parseInt(timer) - userStatsData.user_time_value);
      } else {
        userTime = SecondsToHHMMSS(parseInt(timer) + userStatsData.user_time_value);
      }
    }
    let userChoice =
      userStatsData && userStatsData.questions ? JSON.parse(userStatsData.questions) : '';
    let justification =
      userStatsData && userStatsData.justification ? JSON.parse(userStatsData.justification) : '';
    let usergrading =
      userStatsData && userStatsData.gradings ? JSON.parse(userStatsData.gradings) : '';
    const formatTimeF = SecondsToHHMMSS(seconds);

    const sliderSettings = questionsettings(
      this.props.params.offset ? parseInt(this.props.params.offset) : 1,
    );
    const topSliderSettings = caseCV(
      this.props.params.caseOffset ? parseInt(this.props.params.caseOffset) : 1,
    );
    var parseResult = Object.keys(userChoice).map(function (x) {
      return parseInt(x, 10);
    });
    selectedQuestionData.cfa3_cbt_questions;
    let count = 0;
    parseResult.forEach((element) => {
      let attemptedCount = questionsData.filter((item) => {
        if (item.id === element) {
          count++;
        }
        return item.id === element;
      });
    });

    let content = selectedQuestionData.question;
    if (highlights) {
      highlights.forEach((element) => {
        content = highlightString(content, element.text);
      });
    }
    let text = this.getSelectionHtml();
    let highlighted = `<b style="background-color: yellow" title="highlighted">${text}</b>`;
    let getHighlightedText = content ? content.indexOf(highlighted) : null;
    return (
      <div>
        <div className='animated fadeIn'>
          {casesData && casesData.length ? (
            <div
              className={
                casesData
                  ? casesData.length < 15
                    ? 'margin_bottom_20 ques-title-wrapper pl-0'
                    : 'margin_bottom_20 ques-title-wrapper'
                  : null
              }
            >
              <h1 className='section_head'> {mockName}</h1>
              <div className='finish-btn-wrapper'>
                <Button
                  className='pointer_class btn-primary back-btn'
                  onClick={this.handleGoBackToMock}
                >
                  {language.LC().BACK}
                </Button>
              </div>
            </div>
          ) : (
            <div />
          )}
          {casesData && casesData.length ? (
            <div>
              <div className='row'>
                <div className='col-md-12'>
                  {/* {console.log('casesData.length --------> ', casesData)} */}
                  <div
                    className={
                      casesData.length > 15 ? 'case-tab-wrapper' : 'case-tab-wrapper padding-10'
                    }
                  >
                    <Slider
                      {...topSliderSettings}
                      ref={(slider) => {
                        this.slider = slider;
                      }}
                    >
                      {/* {console.log(this.props.params)} */}
                      {casesData.map((item, index) => {
                        return (
                          <button
                            key={index}
                            onClick={() => this.changeCase(item.id, index)}
                            className={`${
                              item.cfa3_cbt_questions
                                .map((id) => (userChoice[id.id] ? true : false))
                                .indexOf(false) === -1
                                ? true
                                : false
                                  ? ''
                                  : 'bg-completed-cases '
                            }
                              ${
                                index === parseInt(this.props.params.caseOffset)
                                  ? 'active button-trial'
                                  : 'button-trial'
                              }`}
                          >
                            {index + 1}
                          </button>
                        );
                      })}
                    </Slider>
                  </div>
                </div>
                {isLoading ? (
                  <div className='loader-mid full_page'>
                    <div className='card-block-loader'>
                      <Loader />
                    </div>
                  </div>
                ) : (
                  <div className='case-detail-wrapper col-md-12'>
                    <div className='card'>
                      <div className='card-header d-flex justify-content-between qus-header'>
                        {selectedQuestionData && selectedQuestionData.case ? (
                          <div className='ques-wrapper all-ques w-100'>
                            <div className='d-flex align-items-center justify-content-between'>
                              <div className='w-70px' />
                              {renderHTMLContent(selectedQuestionData.case_name, "h1", "text-center mb-2 text-capitalize")}
                              <div className='text-right que-action-arrow mb-2'>
                                <i
                                  className={
                                    this.props.params.caseOffset === '0'
                                      ? `fa fa-angle-left ques_arrow pointer_class hide_block`
                                      : `fa fa-angle-left ques_arrow pointer_class`
                                  }
                                  onClick={this.getPreviousCase}
                                />
                                <i
                                  className={
                                    parseInt(this.props.params.caseOffset) === casesData.length - 1
                                      ? `fa fa-angle-right ques_arrow pointer_class hide_block`
                                      : `fa fa-angle-right ques_arrow pointer_class`
                                  }
                                  onClick={this.getNextCase}
                                />
                              </div>
                            </div>
                            {renderHTMLContent(selectedQuestionData.case, "div", "font-weight-normal", { contentEditable: false })}
                          </div>
                        ) : null}
                      </div>
                    </div>
                  </div>
                )}
              </div>
              {/* ------------------- Questions with answers ---------------- */}
              {isLoading ? (
                ''
              ) : (
                // <div className='loader-mid full_page'>
                //   <div className='card-block-loader'>
                //     <Loader />
                //   </div>
                // </div>
                <div className='row margin_bottom_20 ml-0'>
                  <div className='qus-tab-wrapper height-0'>
                    <Slider
                      {...sliderSettings}
                      ref={(slider) => {
                        this.slider = slider;
                      }}
                    >
                      {questionsData.map((item, index) => {
                        let flaggedQuestions =
                          flag && flag.length
                            ? flag.filter((flag) => flag.question_id === item.id)[0]
                            : '';
                        return (
                          <div className='slide-button' key={index}>
                            <Button
                              key={index}
                              onClick={() => this.changeQuestion(item.id, index)}
                              className={`
                          ${index === parseInt(this.props.params.quesOffset) ? 'active' : ''}
                          ${
                            item.question_type === 'essay_question'
                              ? parseInt(item.max_grading) === parseInt(usergrading[item.id])
                                ? 'right-ans'
                                : parseInt(usergrading[item.id]) === 0
                                  ? 'wrong-ans'
                                  : parseInt(item.max_grading) > parseInt(usergrading[item.id])
                                    ? 'intermediate-grading-answer'
                                    : 'not-ans'
                              : userChoice[item.id] === item.answer ||
                                  userChoice[item.id] === `choice_${item.answer}`
                                ? 'right-ans'
                                : userChoice[item.id] && userChoice[item.id] !== 'no_choice'
                                  ? 'wrong-ans'
                                  : 'not-ans'
                          }
                          ${flaggedQuestions ? 'flag-add' : ''}
                          `}
                            >
                              {flaggedQuestions ? (
                                <img
                                  width='70'
                                  src={App_data.frontend_url + '/img/questions/icon_flag_white.png'}
                                  alt='Question'
                                />
                              ) : (
                                ''
                              )}
                              {index + 1}
                            </Button>
                          </div>
                        );
                      })}
                    </Slider>
                  </div>
                  <div className='ques-detail-wrapper col-md-11 pr-0'>
                    <div className='card'>
                      <div className={'main_loader ' + this.state.display_main_loader}>
                        <div className='loader-mid full_page'>
                          <div className='card-block-loader'>
                            <Loader />
                          </div>
                        </div>
                      </div>
                      <div className='card-header qus-header finish-question-wrapper'>
                        {selectedCaseQuestionData && selectedCaseQuestionData.question ? (
                          <div className='qus-wrapper ques-bold-remove d-block all-ques'>
                            <div>
                              <img
                                src={
                                  App_data.frontend_url +
                                  '/img/question_bank/question_icon_blue.svg'
                                }
                                className='margin_right_20'
                                alt=''
                                width='30'
                              />
                              Q.
                              {parseInt(this.props.params.quesOffset) + 1}
                            </div>
                              {renderHTMLContent(
                                selectedCaseQuestionData.question,
                                "div",
                                "qus-title w-100",
                                { style: { marginTop: "8px" } }
                              )}
                          </div>
                        ) : null}
                        <span className='tooltip_wrap'>
                          <button
                            className='btn btn-primary pointer_class mid-btn'
                            onClick={() => {
                              this.setState({
                                showSectionReview: true,
                              });
                              this.getReadingViseScore();
                            }}
                          >
                            {language.LC().SCORE}
                          </button>
                          <div className='tootip_box'>{language.LC().SHOW_MYSCORE}</div>
                        </span>

                        <span className='tooltip_wrap tooltip_wrap_margin'>
                          <button
                            disabled={
                              (rightanswercount ? rightanswercount : 0) === 0 ? true : false
                            }
                            className={
                              (rightanswercount ? rightanswercount : 0) === 0
                                ? 'cursor_not_Allowed btn btn-primary  mid-btn'
                                : 'btn btn-primary mid-btn'
                            }
                            onClick={() => this.getDetailedResultGraph(totalQuestionCount)}
                          >
                            {language.LC().GRAPH}
                          </button>

                          {rightanswercount ? (
                            rightanswercount === 0 ? null : (
                              <div className='tootip_box'>{language.LC().SHOW_GRAPH}</div>
                            )
                          ) : null}
                        </span>
                      </div>
                      <div className='card-block'>
                        <div className='row'>
                          <div className='col-sm-8 col-lg-9'>
                            {/* ------------ CHOICES ------------- */}
                            {selectedCaseQuestionData &&
                            selectedCaseQuestionData.question_type === 'essay_question' ? (
                              <ViewEssayQuestions
                                {...this.state}
                                {...selectedCaseQuestionData}
                                selectedCaseQuestionData={selectedCaseQuestionData}
                                userChoice={userChoice}
                                justification={justification}
                                disabledTextArea={disabledTextArea}
                              />
                            ) : (
                              <ViewNormalQuestion
                                optionsArr={optionsArr}
                                userChoice={userChoice}
                                selectedCaseQuestionData={selectedCaseQuestionData}
                                questiono={this.props.params.questiono}
                              />
                            )}
                            {/* ------------ CHOICES ------------- */}
                          </div>
                          <div className='col-sm-4 col-lg-3'>
                            <div className='score-wrapper'>
                              <div className='score-inner-cfa3'>
                                {rightanswercount ? rightanswercount : 0}/{totalMaxGrading}
                              </div>
                              <h5>{language.LC().TOTAL_SCORE}</h5>
                              <h5>
                                {language.LC().You_Scored}{' '}
                                {Math.ceil((1 ? rightanswercount * 100 : 0) / totalMaxGrading)}%
                              </h5>
                            </div>
                            <div className='timer_outer finished-time'>
                              <div>
                                <h4>{language.LC().TEST_COMPLETED_IN}</h4>
                                <i className='fa fa-clock-o' />
                                <span className='timer_box'>{userTime}</span>
                              </div>
                            </div>
                          </div>

                          <div className='col-lg-12'>
                            <div className='text-center text-sm-right btm-btn-wrapper quiz-submit-block'>
                              <span className='up tooltip-hover-questions quiz-flag'>
                                <div className='tootip_box'>
                                  {' '}
                                  {language.LC().REPORT_THIS_QUESTION}{' '}
                                </div>
                                <div
                                  className='report-icon-wrapper'
                                  onClick={() => {
                                    this.handleScroll();
                                    this.setState({
                                      report_block: 'card show_block',
                                    });
                                  }}
                                >
                                  <img
                                    src={App_data.frontend_url + '/img/report4.png'}
                                    alt='report'
                                  />
                                </div>
                              </span>
                              <Button
                                onClick={() =>
                                  this.getPreviousQuestion(this.props.params.quesOffset)
                                }
                                className='pointer_class btn-primary'
                                disabled={parseInt(this.props.params.quesOffset) === 0}
                              >
                                <i className='fa fa-angle-left' /> {language.LC().BACK}
                              </Button>
                              <Button
                                onClick={() => this.getNextQuestion(this.props.params.quesOffset)}
                                className='pointer_class btn-primary'
                                disabled={
                                  parseInt(this.props.params.quesOffset) ===
                                  questionsData.length - 1
                                }
                              >
                                {language.LC().NEXT} <i className='fa fa-angle-right' />
                              </Button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
              {/* ------------------- Questions with answer ends------------- */}
              {/* -------------------- CORRECT INCORECT START---------------- */}
              {selectedCaseQuestionData &&
              selectedCaseQuestionData.question_type === 'essay_question' ? (
                <ViewAnswer
                  {...selectedCaseQuestionData}
                  handleChange={this.handleChange}
                  selectedChoice={
                    (userChoice[selectedCaseQuestionData.id] &&
                      selectedCaseQuestionData[userChoice[selectedCaseQuestionData.id]]) ||
                    ''
                  }
                  userGrading={
                    this.state.userGrading || usergrading[selectedCaseQuestionData.id] || ''
                  }
                  disabled={true}
                />
              ) : (
                <ViewNormalAnswer
                  loaderCSS={this.state.display_main_loader}
                  userChoice={userChoice}
                  selectedCaseQuestionData={selectedCaseQuestionData}
                  questiono={this.props.params.questiono}
                />
              )}

              {/* --------------------- CORRECT INCORRECT END --------------- */}
              {/* -------------------- Report section start ----------------- */}
              <div className='row'>
                <div className='col-md-12'>
                  <div className={this.state.report_block}>
                    <div className='card-header'>{language.LC().REPORT}</div>
                    {!this.state.successAlert ? (
                      <div className='card-block'>
                        <div className='row'>
                          <div className='col-xs-12 col-sm-12 col-md-12'>
                            <label className='form-control-label' htmlFor='textarea-input'>
                              <strong>{language.LC().COMMENT}</strong>
                            </label>
                          </div>
                          <div className='col-xs-12 col-sm-12 col-md-12 margin_bottom_10'>
                            <textarea
                              id='comment'
                              name='comment'
                              rows='6'
                              className='form-control'
                              placeholder='Content..'
                            />
                          </div>
                          <div className='error_text ml-1'> {reportError}</div>
                        </div>
                        <div className='row'>
                          <div className='col-xs-12 col-sm-12 col-md-12'>
                            <button
                              type='button'
                              className='btn btn-primary active pointer_class report-btn'
                              disabled={reportLoading}
                              onClick={() => this.reportQuestion(selectedQuestionData.id)}
                            >
                              {reportLoading ? (
                                <span>
                                  <i className='fa fa-spinner fa-spin' />{' '}
                                  {language.LC().PLEASE_WAIT}
                                </span>
                              ) : (
                                language.LC().REPORT
                              )}
                            </button>
                            <button
                              type='button'
                              className='btn btn-danger active pointer_class margin_left_10'
                              onClick={() => this._hideReportForm()}
                            >
                              {language.LC().CANCEL}
                            </button>
                          </div>
                        </div>
                      </div>
                    ) : (
                      <div className='card-block'>
                        <div className='row'>
                          <div className='col-sm-12 report-Success-card'>
                            <img src={App_data.frontend_url + '/img/success-ic.svg'} alt='' />
                            <label className='form-control-label' htmlFor='textarea-input'>
                              <strong> {language.LC().REPORT_SEND_SUCCESS_MESSAGE}</strong>
                            </label>
                            <button
                              type='button'
                              className='btn btn-primary active pointer_class  min-vw-120'
                              onClick={() => {
                                this.setState({
                                  report_block: 'card hide_block',
                                  successAlert: false,
                                });
                              }}
                            >
                              {' '}
                              {language.LC().CLOSE}
                            </button>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
              {/* -------------------- Report section End ------------------- */}
            </div>
          ) : casesData && casesData.length ? (
            <div className='no-qus-found'>
              <img width='105px' src={App_data.frontend_url + '/img/questions/problem.png'} />
              <h3>{language.LC().NO_QUESTION_FOUND}</h3>
              <p> {language.LC().NO_QUESTION_FOR_THIS_EXAM}</p>
            </div>
          ) : (
            <div className='loader-mid full_page'>
              <div className='card-block-loader'>
                <Loader />
              </div>
            </div>
          )}
        </div>
        {/* ========== For Score Side Bar S =============== */}

        <div
          className={`sidebar-review-wrapper sidebar-score-wrapper ${
            showSectionReview ? 'active' : ''
          }`}
        >
          <div className='header-review'>
            <h2> {language.LC().TOPIC_WISE_SCORE}</h2>
            <span
              className='cursor-pointer'
              onClick={() => {
                this.setState({
                  showSectionReview: false,
                });
              }}
            >
              <img width='30px' src={App_data.frontend_url + '/img/questions/icon_close.png'} />
            </span>
          </div>
          <div className='body-review'>
            <ul className='score-list-wrapper'>
              {readingViseScore && readingViseScore.length ? (
                readingViseScore.map((item, index) => {
                  let userGradingOfCurrentChapter = item.questionUserGrading || 0;
                  let readingPercentage =
                    (userGradingOfCurrentChapter * 100) /
                      (item.cfa3_cbt_questions && item.cfa3_cbt_questions[0].questionMaxGrading) ||
                    0;
                  return (
                    <li key={index}>
                      <div>
                        <h4>{item.chapter_name}</h4>
                        <div className='progress custom-prog-bar margin_top_5'>
                          <div
                            className='progress-bar'
                            role='progressbar'
                            style={{
                              width: `${Math.ceil(readingPercentage)}%`,
                            }}
                            aria-valuenow={`${Math.ceil(readingPercentage)}`}
                            aria-valuemin='0'
                            aria-valuemax='100'
                          >
                            {Math.ceil(readingPercentage) ? Math.ceil(readingPercentage) : 0}%
                          </div>
                        </div>
                      </div>
                      <p className='score-inner'>
                        {item.questionUserGrading ? item.questionUserGrading : 0}/
                        {item.cfa3_cbt_questions
                          ? item.cfa3_cbt_questions[0].questionMaxGrading
                          : 0}
                      </p>
                    </li>
                  );
                })
              ) : (
                <div className='no-qus-found no-mock-exam mt-5'>
                  <img
                    width='62px'
                    src={App_data.frontend_url + '/img/questions/icon_nomock.png'}
                  />
                  <h3 className='mt-1'>{language.LC().NO_SCORE_FOUND}</h3>
                </div>
              )}
            </ul>
          </div>
        </div>
        {/* =========For Score Side Bar E============ */}
        <CBTFinishTest
          showFinishTestPopup={showFinishTestPopup}
          submitTest={() => this.submitTest()}
          handleClose={() => this.setState({ showFinishTestPopup: false })}
        />
        <CBTNonAttempted
          showFinishTestPopup={showNonAttemptedPopup}
          submitTest={() =>
            this.setState({
              showFinishTestPopup: true,
              showNonAttemptedPopup: false,
            })
          }
          handleClose={() => this.setState({ showNonAttemptedPopup: false })}
        />
        <CBTFlagged
          showFinishTestPopup={showFlaggedPopup}
          submitTest={() =>
            this.setState({
              showFlaggedPopup: false,
              showFinishTestPopup: true,
            })
          }
          handleClose={() => this.setState({ showFlaggedPopup: false })}
        />
      </div>
    );
  }
}

export default CFAQuestions;



// WEBPACK FOOTER //
// ./src/views/CBT/CFA3CBT/FinishTest/index.js